let env = "demo" //dev //test //prod
let baseUrl;

if (env == "ngrok") {
       baseUrl = "http://ef7a478bafd4.ngrok.io/";
}
if (env == "test") {
       baseUrl = "http://localhost:2053/";
}
if (env == "demo") {
       baseUrl = "https://backend-edafacep2p.maticz.in/";
}


module.exports = {
       baseUrl: baseUrl,
       imageUrl: baseUrl,
};
